import { ChangeEvent, FC, KeyboardEvent, useRef } from 'react';
import { SearchIcon } from '@chakra-ui/icons';
import {
  Box,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@chakra-ui/react';
import { isEmpty } from 'ramda';
import { BiX } from 'react-icons/bi';

type SearchInputProps = {
  onSearch: () => void;
  searchValue: string;
  onChange: (searchTerm: string) => void;
};

export const SearchInput: FC<SearchInputProps> = ({
  onChange,
  onSearch,
  searchValue,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);

  const handleClearSearchInput = () => {
    onChange('');
    searchInputRef.current?.focus();
  };

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.currentTarget.value;
    onChange(searchTerm);
  };

  const handleSearchInputKeydown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <Box>
      <InputGroup size="lg">
        <InputLeftElement pointerEvents="none">
          <SearchIcon color="gray.400" />
        </InputLeftElement>
        <Input
          shadow="sm"
          variant="filled"
          value={searchValue}
          ref={searchInputRef}
          width={{ sm: '56', md: '96' }}
          placeholder="Search for files..."
          onChange={handleSearchInputChange}
          onKeyDown={handleSearchInputKeydown}
          data-testid="search-input"
        />
        {!isEmpty(searchValue) && (
          <InputRightElement>
            <IconButton
              variant="ghost"
              icon={<BiX fontSize="20" />}
              aria-label="Clear search input"
              onClick={handleClearSearchInput}
              data-testid="clear-search-input-btn"
            />
          </InputRightElement>
        )}
      </InputGroup>
    </Box>
  );
};
